<template>
  <div class="hello">
    <div class="home-container" style="opacity: 0;"></div>

    <van-dialog v-model="show1" :closeOnClickOverlay="true" :showConfirmButton="false">
      <div style="width: 100%;padding: 10px 0;">
        <van-radio-group v-model="radio" @change="changex">
          <div style="display: flex;align-items: center;padding: 0 0 0 10px;" v-for="(item, index) in list"
            :key="index">
            <img :src="item.remarks" alt="" class="img" />
            <van-cell :title="item.dictItemName" clickable @click="radio = item.dictItemCode">
              <template #right-icon>
                <van-radio :name="item.dictItemCode" />
              </template>
            </van-cell>
          </div>
        </van-radio-group>
      </div>
    </van-dialog>

    <div class="agreement-confirm-main-box" v-if="flag">
      <div class="agreement-confirm-box">
       
         <div class="backbox" @click="flag=false" >
           <img src="../static/back.png" alt="" class="back"  />
         </div>
			<div class="titles">
				添加银行卡
			</div>
     <div class="box">
       	<div class="title1">
				直接添加
			</div>
      <div  v-for="(item, index) in list"
            :key="index">
            <van-cell-group>
 <van-cell :title="item.dictItemName"  center  is-link :icon="item.remarks" @click="pay(item.dictItemCode)" />
</van-cell-group>

      </div>
     <div class="bottoms">
      	无需卡号直接添加
     </div>
     </div>
        <!-- <van-field v-model="bank" readonly :border="false" @click="show1 = true" placeholder="请选择银行" class="inputn"
          right-icon="arrow-down" />
        <van-field type="digit" readonly :border="false" maxlength="11" v-model="value" placeholder="请输入手机号"
          class="inputn" />
        <van-field type="text" v-model="bankName" :border="false" placeholder="请输入姓名" class="inputn" />
        <van-field type="text" maxlength="18" :border="false" v-model="idCardNo" placeholder="请输入身份证号" class="inputn" />
        <div class="btx " @click="pay">提交</div> -->
      </div>
      <!-- <div @click="flag = false">
        <img src="../static/close.png" alt="" class="imgs" />
      </div> -->
    </div>

    <div>
      <!-- 修改：使用一体化输入框 -->
      <div class="unified-input-container">
        <span class="unified-label">真实姓名：</span>
        <div class="unified-field-wrapper">
          <van-field type="text" @input="namechange" ref="phoneInput" maxlength="11" v-model="bankName" placeholder="(每人仅限参与一次)"
            class="unified-field-input" />
        </div>
      </div>
      <div class="unified-input-container">
        <span class="unified-label">手机号码：</span>
        <div class="unified-field-wrapper">
          <van-field type="digit" @focus="focus" maxlength="11" ref="phoneInput" @input="input" v-model="value" placeholder="(每人仅限参与一次)"
            class="unified-field-input" />
        </div>
      </div>
      <div class="unified-input-container" v-if="showid">
        <span class="unified-label">身份证号：</span>
        <div class="unified-field-wrapper">
          <van-field type="text" maxlength="18" @input="cardchange" ref="phoneInput" v-model="idCardNo" placeholder="(每人仅限参与一次)"
            class="unified-field-input" />
        </div>
      </div>

      <div @click="open">
        <img :src="btnimg" alt="" class="btn" :style="{
          width: pxToVw(btnWidth),
          height: pxToVw(btnHeight)
        }" />
      </div>

      <div class="check">
        <div ref="checkboxWrapper" class="checkbox-wrapper">
          <van-checkbox v-model="checked" @change="changebox">
            <div style="width: 1px;"></div>
          </van-checkbox>
        </div>
        <div class="boss">
          <span v-for="(item, index) in agree" :key="index" class="agreest" :style="color" @click="change(item)">{{
            item.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { userApi, traceApi } from '@/api/index.js'
import CryptoJS from 'crypto-js'
import decryptData from '@/utils/decryptData.js'
import md5 from "@/utils/md5.js"
import JSEncrypt from 'jsencrypt'
import { mixedKey, swapsArray } from '../utils/key.js'
import { restoreShuffle } from '../utils/arrayUtils.js'
import params from "@/utils/param.js"
import { debounce } from 'lodash';
import store from '@/store/index.js'

export default {
  name: "ConTent",
  props: {
    img: String,
    btnimg: String,
    color: String,
    agree: Array,
    a: String,
    productCode: String,
    btnHeight: {
      type: [Number, String],
      default: 60
    },
    btnWidth: {
      type: [Number, String],
      default: 280
    },
    checkboxColor: {
      type: String,
      default: '#fff'
    },
    designWidth: {
      type: Number,
      default: 375
    }
  },
  data() {
    return {
      showid: false,
      bank: '',
      bankCode: "",
      list: [],
      radio: '',
      show1: false,
      bankName: '',
      idCardNo: '',
      flag: false,
      param: "",
      value: '',
      checked: "",
      key: '',
      iv: "",
      data: "",
      decrypt: "",
      judgeType: '',
      env: "",
    };
  },
  watch: {
    checkboxColor: {
      immediate: true,
      handler(newColor) {
        this.$nextTick(() => {
          this.applyCheckboxColor(newColor)
        })
      }
    }
  },
  mounted() {
    this.applyCheckboxColor(this.checkboxColor)
    this.observeCheckboxDOM()
  },
  created() {
    if (/Android/.test(navigator.userAgent)) {
      this.judgeType = 'android'
    }
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      this.judgeType = 'ios'
    }
    this.getEnv()
   
    if (localStorage.getItem('mobile')) {
      this.value = localStorage.getItem('mobile')
    }
    if (params.getParam(this.$route.query)) {
      this.param = params.getParam(this.$route.query)
    }
  },
  methods: {
  
    pxToVw(px) {
      const numPx = Number(px);
      if (isNaN(numPx) || numPx <= 1) return `${px}px`;
      const vwValue = (numPx / this.designWidth) * 100;
      return `${vwValue.toFixed(2)}vw`;
    },

    changex(e) {
      for (var i in this.list) {
        if (this.list[i].dictItemCode == e) {
          this.bank = this.list[i].dictItemName
        }
      }
      console.log(this.bank)
      this.show1 = false
    },

    focus() {
      this.point(3)
    },

    applyCheckboxColor(color) {
      const finalColor = color || '#fff'
      this.$nextTick(() => {
        const icons = document.querySelectorAll('.hello .van-checkbox__icon .van-icon')
        icons.forEach(icon => {
          icon.style.setProperty('border-color', finalColor, 'important')
          icon.style.setProperty('background-color', 'transparent', 'important')
        })

        const checkedIcons = document.querySelectorAll('.hello .van-checkbox__icon--checked .van-icon')
        checkedIcons.forEach(icon => {
          icon.style.setProperty('border-color', finalColor, 'important')
          icon.style.setProperty('color', finalColor, 'important')
          icon.style.setProperty('background-color', 'transparent', 'important')
        })
      })
    },

    observeCheckboxDOM() {
      const observer = new MutationObserver(() => {
        this.applyCheckboxColor(this.checkboxColor)
      })

      if (this.$refs.checkboxWrapper) {
        observer.observe(this.$refs.checkboxWrapper, {
          childList: true,
          subtree: true,
          attributes: true
        })
      }
    },

    getEnv() {
      const ua = navigator.userAgent.toLowerCase()
      const isWechat = ua.includes('micromessenger')
      const isAlipay = ua.includes('alipayclient')
      const isAndroid = /android/.test(ua)
      const isIOS = /ipad|iphone|ipod/.test(ua)

      if (isWechat) {
        if (isAndroid) {
          userApi.fcFast({ userAgent: navigator.userAgent }).then(res => {
            this.env = res.support ? '0' : '1'
            this.$emit('env-change', this.env)
          })
          return
        }
        if (isIOS) {
          this.env = '2'
          this.$emit('env-change', this.env)
          return
        }
      }

      if (isAlipay) {
        this.env = '3'
        this.$emit('env-change', this.env)
        return
      }

      this.env = '4'
      this.$emit('env-change', this.env)
    },

    point(e, n) {
      traceApi.event({
        t: localStorage.getItem('traceId'),
        e: e,
        f: n
      })
    },

    // pay1() {
    //   if (this.bankName == '') {
    //     this.$toast('姓名为空');
    //   } else if (!this.idCardNo.match(
    //     /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/)) {
    //     this.$toast('请输入正确的身份证号');
    //   } else {
    //   this.open()
    //   }
    // },

    pay: debounce(function (e) {
     this.bankCode = e.substring(2)

      this.$store.commit('setLoading', true)
      this.point(9)
      userApi.generateToken({
        channelCode: this.a,
        productCode: this.productCode,
        mobile: this.value,
        traceId: localStorage.getItem('traceId')
      }).then((res) => {
        if (res.reason == 0) {
          this.key = CryptoJS.enc.Utf8.parse(md5.hex_md5(res.i))
          this.iv = CryptoJS.enc.Utf8.parse(res.i + '000')
          this.data = res.t

          userApi.register({
            mobile: this.value
          }).then((res1) => {
            localStorage.setItem('token', res1.accessToken);
            const encryptedData = CryptoJS.enc.Base64.parse(this.data);
            this.decrypt = decryptData.decryptData(encryptedData, this.key, this.iv)

            userApi.getchannel({
              channelCode: this.a
            }).then((res2) => {
              const decrypt = new JSEncrypt();
              decrypt.setPrivateKey(restoreShuffle(mixedKey.split('/'), swapsArray).join('/'))
              const decryptex = decrypt.decrypt(res2);
              const decryptexs = CryptoJS.enc.Utf8.parse((decryptex))

              var content = JSON.stringify({
                mobile: this.value,
                paymentMethod: "6",
                orderType: "1",
                channelCode: this.a,
                productCode: this.productCode,
                param: this.param,
                redirectUrl: window.location.href,
                userName: this.bankName,
                idCardNo: this.idCardNo,
                bankCode: this.bankCode,
              })
              const timestamp = Math.floor(new Date().getTime())
              var encryptResult = decryptData.cryptData(content, decryptexs, CryptoJS.enc.Utf8.parse(timestamp + '000'))

              userApi.signOrderHlb({
                channelCode: this.a,
                data: encryptResult,
                iv: timestamp + '000',
                t: this.decrypt,
                traceId: localStorage.getItem('traceId')
              }).then((res3) => {
                if (res3.reason == 0) {
                  this.$store.commit('setLoading', false)
                  let key = CryptoJS.enc.Utf8.parse(md5.hex_md5(this.decrypt))
                  let url = decryptData.decryptData(
                    CryptoJS.enc.Base64.parse(res3.encryptData),
                    key,
                    CryptoJS.enc.Utf8.parse(timestamp + '000')
                  )

                  let urls = JSON.parse(url).extInfo.signUrl
                  let signUrlHtmL = JSON.parse(url)
                    .extInfo?.signUrl.replace(
                      /\\/g, '')
                  //先判断.home-container下是否存在name==E_FORM的表单
                  if (document.querySelector(
                    'form[name="E_FORM"]')) {
                    //如果存在，则先删除
                    document.querySelector(
                      'form[name="E_FORM"]')
                      .remove()
                  }
                  //将signUrlHtmL插入类名为home-container的div最底部
                  document.querySelector(
                    '.home-container')
                    .insertAdjacentHTML(
                      'beforeend', signUrlHtmL)
                  //手动提交 name==E_FORM 的表单
                  document.querySelector(
                    'form[name="E_FORM"]')
                    .submit()
                }
              })
            })
          })
        }
      })
    }, 300),

    open() {
      console.log(this.bankName)
      if (this.bankName == '') {
        return this.$toast('姓名为空');
      }
      if (!this.idCardNo.match(
        /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/)) {
        return this.$toast('请输入正确的身份证号');
      }
      if (!/^1[3456789]\d{9}$/.test(this.value)) {
        return this.$toast('请输入正确的手机号');
      }
      userApi.queryDictInfoHlb().then((res) => {
        console.log(res)
        this.list = res.dictItemList
        this.list.sort((a, b) => a.dictItemCode.substring(0, 2) - b.dictItemCode.substring(0, 2))
        console.log(this.list)
        setTimeout(() => {
          this.radio = this.list[0].dictItemCode
          this.bank = this.list[0].dictItemName
          this.flag = true
        }, 100);
      })

    },

    changebox(e) {
      if (e == true) {
        traceApi.event({
          t: localStorage.getItem('traceId'),
          obj: 5
        })
      }
    },

    change(e) {
      console.log(e)
      if (e.url) {
        window.location.href = e.url
      } else {
        console.log(e.id)
        if (e.id == 1) {
          this.$emit('ys', true)
        } else if (e.id == 3) {
          this.$emit('rule', true)
        }
      }
    },
    namechange() {
      if (this.bankName.length > 0 && this.value.length == 11) {
        this.showid = true
      } else {
        this.showid = false
      }
    },
    cardchange() {
      if (this.idCardNo.length == 18) {
        this.closejp()
        this.open()
      }
    },
    closejp(){
       this.$nextTick(() => { // 确保 DOM 更新后执行
          const inputEl = this.$refs.phoneInput?.$el.querySelector('.van-field__control');
          inputEl?.blur();
        });
    },
    input() {
      if (this.value.length == 11) {
        if (!/^1[3456789]\d{9}$/.test(this.value)) {
          return this.$toast('请输入正确的手机号');
        }
        this.showid = true
        traceApi.event({
          t: localStorage.getItem('traceId'),
          e: 4,
          obj: this.value
        })
        localStorage.setItem('mobile', this.value)
    
      } else {
        this.showid = false
      }
    }
  }
}
</script>

<style scoped>
/* 核心：一体化输入框样式 */
.unified-input-container {
  display: flex;
  align-items: center;
  /* 容器内部元素纵向居中 */
  width: 276px;
  height: 45px;
  background: #FFFFFF !important;
  /* 强制白色背景 */
  border-radius: 25px;
  margin: 0 auto 6px auto;
  box-sizing: border-box;
  overflow: hidden;
  /* 确保圆角效果 */
  border: none;
  box-shadow: none;
}

.unified-label {
  flex-shrink: 0;
  padding: 0 0 0 15px;
  font-size: 15px;
  color: #333;

  height: 100%;
  display: flex;
  align-items: center;
  /* label文本纵向居中 */

  background: #FFFFFF;
  /* label也有白色背景 */
}

.unified-field-wrapper {
  flex: 1;
  height: 100%;
  background: #FFFFFF;
  /* 输入框区域背景 */
  display: flex;
  align-items: center;
  /* 输入框区域内部纵向居中 */
}

.unified-field-input {
  width: 100%;
  height: 100%;
  background: #FFFFFF !important;
  /* 确保输入框背景为白色 */
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  display: flex;
  align-items: center;
  /* 输入框组件纵向居中 */
}

/* 穿透修改Vant输入框样式 */
:deep(.unified-field-input .van-field__control) {
  background: #FFFFFF !important;
  height: 100% !important;
  /* 确保高度100% */
  border: none !important;
  font-size: 16px;

  color: #333;
  display: flex !important;
  /* 使用flex布局 */
  align-items: center !important;
  /* 输入文本纵向居中 */
}

/* 调整placeholder字体大小 */
:deep(.unified-field-input .van-field__control::placeholder) {
  font-size: 14px !important;
  color: red !important;
  line-height: normal !important;
  /* 清除默认行高影响 */
}

/* 确保输入文本也垂直居中 */
:deep(.unified-field-input .van-field__control input) {
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
  padding: 0 !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

/* 移除输入框的默认边框和阴影 */
:deep(.unified-field-input .van-field) {
  background: #FFFFFF !important;
  border: none !important;
  padding: 0 !important;
  height: 100% !important;
  border-radius: 0 !important;
  display: flex !important;
  align-items: center !important;
}

:deep(.unified-field-input .van-cell) {
  background: #FFFFFF !important;
  padding: 0 !important;
  height: 100% !important;
  border-radius: 0 !important;
  display: flex !important;
  align-items: center !important;
}

/* 确保van-field__body也垂直居中 */
:deep(.unified-field-input .van-field__body) {
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
}

/* 确保所有背景都是白色 */
:deep(.unified-field-input .van-field__body),
:deep(.unified-field-input .van-field__value) {
  background: #FFFFFF !important;
}

/* 其他原有样式保持不变 */
@keyframes butChange {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

.hello {
  font-size: 20px;
  max-width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
}

.btn {
  animation: butChange 1s infinite;
  margin-top: 19px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  object-fit: contain;
}

.check {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0 auto;
  margin-top: 10px;
  width: 90%;
  max-width: 320px;
  justify-content: flex-start;
  box-sizing: border-box;
  line-height: 14px;
}

.checkbox-wrapper {
  margin: 0 4px 0 0;
  flex-shrink: 0;
  padding: 0;
  display: flex;
  align-items: center;
  height: 14px;
}

.boss {
  flex: 1;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  margin: 0;
  padding: 0;
  line-height: 4px;
  text-align: left;
  overflow-wrap: break-word;
  box-sizing: border-box;
  font-size: 12px;
}

.agreest {
  line-height: 14px;
  display: inline;
  white-space: normal;
  word-break: break-all;
  cursor: pointer;
  margin: 0 !important;
  padding: 0 !important;
}

.agreest::after {
  content: none !important;
}

.check * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.hello>div {
  margin: 0;
  padding: 0;
}

@media (max-width: 375px) {
  .check {
    width: 90%;
  }

  .checkbox-wrapper {
    margin: 0 3px 0 0;
  }

  .unified-input-container {
    width: 276px;
  }

  .unified-label {
    font-size: 15px;
    padding: 0 12px;
  }
}

@media (max-width: 320px) {
  .check {
    width: 95%;
  }

  .agreest {
    line-height: 12px;
  }

  .unified-input-container {
    width: 276px;
    height: 45px;
  }

  .unified-label {
    font-size: 14px;
    padding: 0 10px;
  }

  :deep(.unified-field-input .van-field__control) {
    font-size: 15px;
  }

  :deep(.unified-field-input .van-field__control::placeholder) {
    font-size: 13px !important;
  }
}

/* 弹窗中的输入框也统一placeholder样式 */
:deep(.inputn .van-field__control::placeholder) {
  font-size: 14px !important;
  color: #999 !important;
}

/* 百度浏览器弹窗背景兼容 */
.agreement-confirm-main-box {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-flex-direction: column;
  flex-direction: column;
  
  background-color: rgba(0, 0, 0, 0.7) !important;
  z-index: 2;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  position: absolute;
  position: fixed;
  padding: 10px;
}

.agreement-confirm-main-box .agreement-confirm-box {
 

  width: 100%;
  height: 100vh;


  background-color: #EDEDED;
}

.inputn {
  height: 40px;
  border-radius: 6px;
  -webkit-border-radius: 6px;
  margin-top: 8px;
  border: 1px solid #EBEBEB;
}

.van-cell {
  line-height: 24px;
  padding: 12px 16px 10px 0;
}

.van-cell__title {
  text-align: left;
}

.img {
  width: 21px;
  height: 21px;
}

.imgs {
  width: 24px;
  height: 24px;
  margin-top: 4px;
}

.btx {
  width: 100%;
  height: 40px;
  background: #FF7E00;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  margin-top: 29px;
  color: #fff;
  font-size: 18px;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}

:deep(.van-checkbox__icon) {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  flex: none;
  height: 1em;
  font-size: 15px !important;
  line-height: 1em;
  cursor: pointer;
}
:deep(.van-cell__left-icon){
 
  width: 40px;
  font-size: 30px;
  display: flex;
  align-items: center;
}
.back{
  
  height: 18px;
}
.backbox{
  padding-left: 2.8vw;
   padding-top: 2.8vw;
  text-align: left;
  width: 100%;

}
.titles{
  font-size: 15px;
}
.title1{
   
 
  text-align: left;
  width: 100%;
    font-size: 14px;
    padding: 10px 0;
 padding-left: 2.8vw;
 
}
.box{
 background: #fff;
  border-radius: 20px;
  width: 90%;
  margin: 0 auto;
  margin-top: 16px;
  padding: 6px 6px 10px 6px;
  /* 新增/修改以下属性 */
  max-height: 100vh; /* 限制最大高度（根据需求调整，如50vh/70vh） */
 
  box-sizing: border-box; /* 确保padding不超出宽度 */
  -webkit-overflow-scrolling: touch; /* 兼容iOS顺滑滚动 */
  
  
  
}
.bottoms{
  color: #646A90;
  font-size: 14px;
  margin-top: 10px;
}
:deep(.box .van-cell-group .van-cell) {
  padding: 8px 14px 6px 0; /* 原12px 16px 10px 0，减少上下内边距 */
  line-height: 16px; /* 原24px，适当缩小行高 */
  font-size: 13px;
}
.agreement-confirm-main-box .agreement-confirm-box {
  width: 100%;
  height: 100vh;
  background-color: #EDEDED;
  /* 新增：避免内容溢出父容器 */
  overflow: hidden; 
  box-sizing: border-box;
  padding-bottom: 20px; /* 底部留空，避免滚动到底部被遮挡 */
}
</style>